import React from 'react';

const RelationshipCheck = ({ updateFormData, nextStep, prevStep }) => {
  const handleAnswer = (answer) => {
    updateFormData({ isConsanguineous: answer });
    nextStep();
  };

  return (
    <div className="question-screen">
      <button onClick={prevStep} className="btn btn-secondary question-back-button">
        Back to Previous Question
      </button>

      <h1 className="question-title">RELATIONSHIP OF APPLICANTS</h1>
      <p className="question-subtitle">Reference: <a href="https://www.legis.la.gov/legis/Law.aspx?d=111053" target="_blank" rel="noopener noreferrer">La. R.S. 9:224 / La. Civil Code Article 90</a></p>


      <div className="question-content">
        <h4>Is this a consanguineous relationship?</h4>
        <p className="question-note">
          (Meaning parties are of the same blood or origin; specifically relating to or involving persons, i.e. first cousins, who are closely related.)
        </p>

        <h4>La. Civil Code Article 90 provides:</h4>
        <p><strong>A.</strong> The following persons may not contract marriage with each other:</p>
        <ol>
          <li>Ascendants and descendants.</li>
          <li>Collaterals within the fourth degree, whether of the whole or of the half blood.</li>
        </ol>

        <p>
          <strong>B.</strong> The impediment exists whether the persons are related by consanguinity or by adoption.
          Nevertheless, persons related by adoption, though not by blood, in the collateral line within the fourth degree
          may marry each other if they obtain judicial authorization in writing to do so.
        </p>

        <p className="question-prompt">Is this a consanguineous relationship?</p>
      </div>

      <div className="question-buttons">
        <button onClick={() => handleAnswer(true)} className="question-btn yes">Yes</button>
        <button onClick={() => handleAnswer(false)} className="question-btn no">No</button>
      </div>
    </div>
  );
};

export default RelationshipCheck;
